import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/food_list_empty.png'


const _hoisted_1 = { class: "pantry-ingredient-empty-view" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-ingredient-empty-image",
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "pantry-ingredient-empty-view-text" }, "食材の候補はありません", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}